export default [{
        path: '/feedback',
        name: 'feedback',
        component: () =>
            import ('@/components/page/storeFeedback/storeFeedbackList'),
        meta: { title: '问题报告' } //反馈单-列表
    },
    {
        path: '/storeFeedback-detail',
        name: 'feedbackDetail',
        component: () =>
            import ('@/components/page/storeFeedback/storeFeedbackDetail'),
        meta: { title: '问题报告详情' } //反馈单-详情
    }
]